import React, { useContext, useEffect, useState } from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';
import MarkEmailReadOutlinedIcon from '@mui/icons-material/MarkEmailReadOutlined';
import RadioButtonUncheckedRoundedIcon from '@mui/icons-material/RadioButtonUncheckedRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { FormData } from '../../CreateQuestionnaire';
import { useAutoTranslation } from 'src/hooks/useTranslate';
import styles from './Settings.module.css';

const options = [
  {
    label: 'No action',
    value: 0,
    description: 'Nothing happens after the form is submitted.',
    icon: <BlockOutlinedIcon />
  },
  {
    label: 'Send email with populated PDFs',
    value: 1,
    description:
      'Email the submitted responses as populated PDF documents once the form is completed.',
    icon: <MarkEmailReadOutlinedIcon />
  }
];

export default function Settings() {
  const [formDataContext, setFormDataContext] = useContext(FormData);
  const [selectedOption, setSelectedOption] = useState(
    formDataContext.postActions || '0'
  );
  const t = useAutoTranslation();

  useEffect(() => {
    setFormDataContext({ ...formDataContext, postActions: selectedOption });
  }, [selectedOption]);

  return (
    <div className={styles.page}>
      {/* <div className={styles.banner}>
        <InfoOutlinedIcon fontSize="small" />
        <span>
          {t('Choose what happens after a respondent submits this form.')}
        </span>
      </div> */}

      <div className={styles.card}>
        <div className={styles.cardHeader}>
          <h2 className={styles.cardTitle}>
            {t('Configure post submission action')}
          </h2>
          <p className={styles.cardSubtitle}>
            {t('Select the action to run when the form is submitted.')}
          </p>
        </div>

        <div className={styles.optionList}>
          {options.map((option) => {
            const selected = String(selectedOption) === String(option.value);
            return (
              <button
                type="button"
                key={option.value}
                className={
                  selected
                    ? `${styles.option} ${styles.optionSelected}`
                    : styles.option
                }
                onClick={() => setSelectedOption(String(option.value))}
              >
                <span className={styles.optionIcon}>{option.icon}</span>
                <span className={styles.optionBody}>
                  <span className={styles.optionLabel}>{t(option.label)}</span>
                  <span className={styles.optionDesc}>
                    {t(option.description)}
                  </span>
                </span>
                <span className={styles.radio}>
                  {selected ? (
                    <CheckCircleRoundedIcon />
                  ) : (
                    <RadioButtonUncheckedRoundedIcon />
                  )}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
